<div [ngClass]="getStatusClass()">
    <div [ngClass]="getBodyStatusClass()">
    <div style="width: 18px; text-align: center; color: white; font-size: 10px; font-family: Roboto; font-weight: 400; word-wrap: break-word">{{this.statusDescription.substring(0,1).toLocaleUpperCase()}}</div>
    <div style="width: 18px; height: 18px; position: relative; transform: rotate(-90deg); transform-origin: 0 0"></div>
    </div>
    <div style="padding-left: 6px; padding-right: 6px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
    <div [ngClass]="getFontStatusClass()">{{this.statusDescription}}</div>
    </div>
    </div>
